<div *ngIf="pageDesignFlag">
  <div id="{{pageDesign.name}}" [ngStyle]="pageDesign.style" class="welcome-div"  [ngClass]="{'level-trans': scroll}">
    
    <div class="full-width">
      
      <!-- CUSTOM CODE SECTION -->
      <div *ngIf="customDesign">
        <div [innerHTML]="htmlText | sanitizeHtml"></div>
      </div>

      <!-- NON CUSTOM CODE SECTION -->
      <div *ngIf="!customDesign">
        
        <!-- PAGE DIVISION ENABLED -->
        <div *ngIf="pageDivision">

          <!-- TWO COLOUMNS -->
          <div [ngStyle]="pageDivStyle">

            <div [ngStyle]="pageLeftScreenStyle">

              <div *ngFor="let ele of pageDesign.left_screen_element_flow" class="element-div">
              
                <img class="tangent_img" *ngIf="ele.type=='image'" src="{{ele.src}}" alt="" srcset="" [ngStyle]="ele.style" >
              
                <p *ngIf="ele.type=='text'" [ngStyle]="ele.style">{{ele.text}}</p>
              
                <p *ngIf="ele.type=='sub-text' && ele.text!= 'null'" [ngStyle]="ele.style">{{ele.text}}</p>
              
                <p *ngIf="ele.type=='link'" [ngStyle]="ele.style">{{ele.text}}&nbsp;<a [href]="ele.link" target="_blank">{{ele.linkText}}</a></p>
            
                <button mat-raised-button *ngIf="ele.type=='button'" [ngStyle]="ele.style"
                  (click)="customService.triggerFunction(ele)">{{ele.text}}</button>
          
                <label for="file-upload" *ngIf="ele.type=='file-input'" [ngStyle]="ele.style"
                  (click)="customService.triggerFunction(ele)">
                  {{ele.text}}
                </label>
          
                <input class="explore-button" *ngIf="ele.type=='file-input'" id="file-upload" type="file" accept="image/png, image/jpeg"
                  (change)="fileProgress($event)" #photoInput />
          
              </div>
    
            </div>
            <div [ngStyle]="pageRightScreenStyle">
              <div *ngFor="let ele of pageDesign.right_screen_element_flow" class="element-div">
                <img *ngIf="ele.type=='image'" src="{{ele.src}}" alt="" srcset="" [ngStyle]="ele.style">
                <p *ngIf="ele.type=='text'" [ngStyle]="ele.style">{{ele.text}}</p>
                <p *ngIf="ele.type=='sub-text' && ele.text!= 'null'" [ngStyle]="ele.style">{{ele.text}}</p>
                <p *ngIf="ele.type=='link'" [ngStyle]="ele.style">{{ele.text}}&nbsp;<a [href]="ele.link" target="_blank">{{ele.linkText}}</a></p>
            
                <button mat-raised-button *ngIf="ele.type=='button'" [ngStyle]="ele.style"
                  (click)="customService.triggerFunction(ele)">{{ele.text}}</button>
          
                <label for="file-upload" *ngIf="ele.type=='file-input'" [ngStyle]="ele.style"
                  (click)="customService.triggerFunction(ele)">
                  {{ele.text}}
                </label>
          
                <input class="explore-button" *ngIf="ele.type=='file-input'" id="file-upload" type="file" accept="image/png, image/jpeg"
                  (change)="fileProgress($event)" #photoInput />
          
              </div>
            </div>
          </div>

          <!-- ROW WISE -->
          <div>
            <div *ngFor="let ele of pageDesign.element_flow" class="element-div">
              <img *ngIf="ele.type=='image'" src="{{ele.src}}" alt="" srcset="" [ngStyle]="ele.style">
              <p *ngIf="ele.type=='text'" [ngStyle]="ele.style">{{ele.text}}</p>
              <p *ngIf="ele.type=='sub-text' && ele.text!= 'null'" [ngStyle]="ele.style">{{ele.text}}</p>
              <p *ngIf="ele.type=='link'" [ngStyle]="ele.style">{{ele.text}}&nbsp;<a [href]="ele.link" target="_blank">{{ele.linkText}}</a></p>
          
              <button mat-raised-button *ngIf="ele.type=='button'" [ngStyle]="ele.style"
                (click)="customService.triggerFunction(ele)">{{ele.text}}</button>
        
              <label for="file-upload" *ngIf="ele.type=='file-input'" [ngStyle]="ele.style"
                (click)="customService.triggerFunction(ele)">
                {{ele.text}}
              </label>
        
              <input class="explore-button" *ngIf="ele.type=='file-input'" id="file-upload" type="file" accept="image/png, image/jpeg"
                (change)="fileProgress($event)" #photoInput />
            </div>
          </div>

        </div>
              
        <!-- PAGE DIVISION DISABLED -->
        <div *ngIf="!pageDivision">
          
          <div *ngFor="let ele of pageDesign.element_flow" class="element-div">
          
            <img *ngIf="ele.type=='image'" src="{{ele.src}}" alt="" srcset="" [ngStyle]="ele.style">
          
            <p *ngIf="ele.type=='text'" [ngStyle]="ele.style" [innerHTML]="ele.text | sanitizeHtml"></p>
          
            <p *ngIf="ele.type=='sub-text' && ele.text!= 'null'" [ngStyle]="ele.style" [innerHTML]="ele.text | sanitizeHtml"></p>
          
            <p *ngIf="ele.type=='link'" [ngStyle]="ele.style" [innerHTML]="ele.text | sanitizeHtml">&nbsp;<a [href]="ele.link" target="_blank">{{ele.linkText}}</a></p>
        
            <button mat-raised-button *ngIf="ele.type=='button'" [ngStyle]="ele.style"
              (click)="customService.triggerFunction(ele)" [innerHTML]="ele.text | sanitizeHtml"></button>
      
            <label for="file-upload" *ngIf="ele.type=='file-input'" [ngStyle]="ele.style"
              (click)="customService.triggerFunction(ele)" [innerHTML]="ele.text | sanitizeHtml">
            </label>
      
            <input class="explore-button" *ngIf="ele.type=='file-input'" id="file-upload" type="file" accept="image/png, image/jpeg"
              (change)="fileProgress($event)" #photoInput />
      
            <div *ngIf="ele.type=='custom'" [innerHTML]="ele.custom_html | sanitizeHtml"></div>

          </div>

        </div>

      </div>
      
    </div>

  </div>
</div>
